import React from 'react';
import banner from './img/courses-bannner.png'
import './AD-cyber-page.css';
import CareerForm from './careerform';
import Footer from '../Components/footer'

const ciscoPage = () => {
  return (
    <div className='cisco-container'>
       <div className='cisco-banner-box'>
                  <div className='cisco-banner'>
        <img src={banner} alt=''/>
                  </div>
                </div>
<div className='detail-box'>
    <div className='cisco-heading'>
        <h1>Advance Cyber Security Course </h1>
        <p>Our Advanced Cybersecurity Course is built for people who are serious about becoming the experts that organisations actually rely on. You will go deep into penetration testing, advanced threat hunting, malware analysis, incident response, and security operations — all through live labs and real-world attack scenarios.
</p>
        </div> 
        <div className='carrer-section'>
        <div className='skills-section'>
<h2>🛡️ Top Advanced Cyber Security Skills You’ll Master</h2>
<div className='skills-name'>
<span>Ethical Hacking Techniques</span>
<span>Penetration Testing Skills</span>
</div>
<div className='skills-name'>
  <span>Threat Detection & Response</span>
  <span>Network Security & Defense</span>
</div>
<div className='skills-name'>
<span>Vulnerability Assessment & Analysis</span>
</div>

        </div>
        <div className='job-roles'>
           <h1>💼 JOB ROLES AFTER COURSE</h1>
           <div className='job-name'>
            <span>Red Team Engineer</span>
            <span>Penetration Tester</span>
            </div>
             <div className='job-name'>
            <span>SOC Analyst (L2/L3)</span>
            <span>Security Consultant</span>
            </div>
             <div className='job-name'>
            <span>Bug Bounty Hunter</span>
           </div>
        </div>
        </div>
        <div className='course-discription'>
            <h1>About this Course</h1>
<p>The Advanced Cyber Security Course is designed for those who want to go beyond basics and master real-world security skills. Our Advanced Cybersecurity Course prepares you for exactly that. From ethical hacking and exploit development to SIEM management, forensic investigation, and red team operations, every module is designed around what senior security roles demand. You already understand the fundamentals. Now it is time to think like the attacker — and defend like a pro. Advanced Cybersecurity Course pushes you into the deep end: advanced penetration testing, zero-day vulnerabilities, digital forensics, cloud security, and red vs blue team exercises. Every lab mirrors a real organisation's environment, so nothing feels theoretical.
</p>
        </div>
        </div>
        <div className='join-container'>
        <div className='join-box'>
<div className='join-div'>
<h1>Who Should Join This Advanced Cyber Security Course</h1>
<p><span> ✔ </span> Students ready to become Cybersecurity Experts, not just learners.</p>
<p><span> ✔ </span>Freshers who want a powerful IT career start with advanced security skills.</p>
<p><span> ✔ </span>Beginners who are serious about becoming ethical hackers & cyber defenders.</p>
<p><span> ✔ </span>Network engineers aiming to master advanced security & real-world protection.</p>
<p><span> ✔ </span>IT professionals who want to move into high-paying cybersecurity roles.</p>
<p><span> ✔ </span>Working professionals planning a confident career switch into cyber domain.</p>
<p><span> ✔ </span>Freelancers who want to offer trusted and in-demand cybersecurity services.</p>
<p><span> ✔ </span>Self-learners looking for clear, practical & industry-ready training path.</p>
<p><span> ✔ </span>Tech enthusiasts passionate about protecting data, systems & digital world.</p>
<p><span> ✔ </span>Anyone who wants a secure, respected & future-proof career in cybersecurity.</p>

</div>
        </div>

                <CareerForm/>
        </div>
    <div className="modules-container">

      {/* Heading */}
      <h1 className="module">Course RoadMap</h1>
      <p className="subtitle">
        Step-by-step modules to master Advanced Cyber Security Course
      </p>

      {/* Grid */}
      <div className="modules-grid">

        {/* Card 1 */}
        <div className="module-card">
          <div className="circle">01</div>
          <h3>Advanced Cyber Security Overview</h3>
          <p>
            Understand advanced cybersecurity concepts, frameworks, and enterprise-level security architecture fundamentals.
          </p>
        </div>

        {/* Card 2 */}
        <div className="module-card">
          <div className="circle">02</div>
          <h3>Advanced Network Security</h3>
          <p>
            Implement IDS, IPS, firewalls, and secure enterprise network infrastructure configurations.
          </p>
        </div>

        {/* Card 3 */}
        <div className="module-card">
          <div className="circle">03</div>
          <h3>Ethical Hacking & Penetration Testing</h3>
          <p>
           Perform advanced penetration testing, vulnerability exploitation, and real-world attack simulations.
          </p>
        </div>

        {/* Card 4 */}
        <div className="module-card">
          <div className="circle">04</div>
          <h3>Web Application Security (Advanced)</h3>
          <p>
            Identify and exploit advanced web vulnerabilities and implement secure coding practices.
          </p>
        </div>

        {/* Card 5 */}
        <div className="module-card">
          <div className="circle">05</div>
          <h3>Malware Analysis & Reverse Engineering</h3>
          <p>
      Analyze malware behavior and perform basic reverse engineering techniques safely.
          </p>
        </div>

        {/* Card 6 */}
        <div className="module-card">
          <div className="circle">06</div>
          <h3>Digital Forensics & Incident Response</h3>
          <p>
           Investigate cyber incidents, collect evidence, and perform structured incident response processes
          </p>
        </div>

      </div>

       {/* Grid */}
      <div className="modules-grid">

        {/* Card 7 */}
        <div className="module-card">
          <div className="circle">07</div>
          <h3>Cloud Security (Advanced)</h3>
          <p>
            Secure cloud environments, manage risks, and implement cloud security best practices.
          </p>
        </div>

        {/* Card 8 */}
        <div className="module-card">
          <div className="circle">08</div>
          <h3>Cryptography & Encryption (Advanced)</h3>
          <p>
           Implement encryption algorithms, PKI, and secure communication in modern systems.
          </p>
        </div>

        {/* Card 9 */}
        <div className="module-card">
          <div className="circle">09</div>
          <h3>Security Operations (SOC)</h3>
          <p>
         Monitor threats, analyze logs, and manage security operations center activities.
          </p>
        </div>

        {/* Card 10 */}
        <div className="module-card">
          <div className="circle">10</div>
          <h3>Risk Management & Compliance</h3>
          <p>
            Assess risks, implement policies, and follow cybersecurity laws and compliance standards.
          </p>
        </div>

        {/* Card 11 */}
        <div className="module-card">
          <div className="circle">11</div>
          <h3>Threat Intelligence & Analysis</h3>
          <p>
           Analyze cyber threats, attacker techniques, and proactive defense strategies effectively.
          </p>
        </div>

        {/* Card 12 */}
        <div className="module-card">
          <div className="circle">12</div>
          <h3>Wireless & Mobile Security</h3>
          <p>
           Secure wireless networks and protect mobile devices from advanced cyber attacks.
          </p>
        </div>

      </div>
    </div>

<div>
        <Footer/>
</div>
    </div>
  )
}

export default ciscoPage
